import { Fragment } from 'react';

import { Empty, EmptyActions, EmptyContent, EmptyDescription, EmptyTitle } from '@playbooks/ui/components/empty';
import { EmptyMedia } from '@playbooks/ui/components/empty';
import { Icon, resolveIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

import type { FeedbackInternalProps } from './types';

const PreviewFeedback = ({ icon, title, text, actions, className }: FeedbackInternalProps) => {
	// Theme
	const rootClassName = cn('m-4 p-4', className);

	// Render
	return (
		<Fragment>
			<Empty className={rootClassName}>
				<EmptyContent>
					{icon && (
						<EmptyMedia>
							<Icon {...resolveIcon(icon, 'fad')} aria-hidden />
						</EmptyMedia>
					)}
					{title && <EmptyTitle>{title}</EmptyTitle>}
					{text && <EmptyDescription>{text}</EmptyDescription>}
				</EmptyContent>
			</Empty>
			{actions && <EmptyActions className='flex-between w-full gap-4 py-4'>{actions}</EmptyActions>}
		</Fragment>
	);
};
export { PreviewFeedback };
